export default "__VITE_ASSET__BwrLih9H__"